import { useTranslation } from "react-i18next";

import { Button } from "../../../components/Button";
import InputVerificationCode from "../../../components/Form/InputVerificationCode";
import { FormGroup, Form } from "../../../components/Form/styles";
import { Box } from "../../../components/Layout";
import { RegisterPageProps } from "../types";

const RegisterStep3Page = ({
  activationCode,
  setActivationCode,
  onNextStep,
  onPreviousStep,
  loading,
  resending = false,
  onResendCode,
  resendCodeCooldownSeconds,
}: RegisterPageProps & {
  activationCode: string;
  setActivationCode: (value: string) => void;
  onNextStep: () => void;
  onPreviousStep: () => void;
  loading: boolean;
  /** The code is being sent again (not just any request, like checking the code). */
  resending?: boolean;
  onResendCode: () => void;
  resendCodeCooldownSeconds: number;
}) => {
  const { t } = useTranslation();
  const isResendCodeBlocked = resendCodeCooldownSeconds > 0;
  const cooldownMinutes = Math.floor(resendCodeCooldownSeconds / 60);
  const cooldownSeconds = resendCodeCooldownSeconds % 60;
  const cooldownDisplay = `${cooldownMinutes.toString().padStart(2, "0")}:${cooldownSeconds.toString().padStart(2, "0")}`;
  const resendCodeText = resending
    ? t("pages.register.reenviteCodeLoading")
    : isResendCodeBlocked
      ? `${t("pages.register.reenviteCodeText")} (${cooldownDisplay})`
      : t("pages.register.reenviteCodeText");

  return (
    <Box className="!mx-0 !mt-0" borderBottom>
      <Form
        className="flex flex-col"
        onSubmit={e => {
          e.preventDefault();
          if (!(activationCode.length !== 5 || loading)) {
            onNextStep();
          }
        }}>
        <FormGroup className="flex !flex-row gap-4">
          <InputVerificationCode value={activationCode} onChange={setActivationCode} />
        </FormGroup>
        <button
          type="button"
          onClick={onResendCode}
          disabled={loading || isResendCodeBlocked}
          className="typography-p mb-12 text-left text-gray-600 underline disabled:cursor-not-allowed disabled:opacity-60">
          {resendCodeText}
        </button>
        <Button
          onClick={() => onNextStep()}
          type="INFO"
          size="LG"
          block
          disabled={activationCode.length !== 5 || loading}
          $loading={loading}>
          {t("pages.register.registerButton.confirm")}
        </Button>
        {/* The visible Button is a styled div; this lets Enter submit the form */}
        <button type="submit" className="sr-only" tabIndex={-1} aria-hidden="true" />
        <button
          type="button"
          onClick={onPreviousStep}
          className="typography-p mt-4 text-center text-xs font-bold underline">
          {t("pages.register.backPage")}{" "}
        </button>
      </Form>
    </Box>
  );
};

export default RegisterStep3Page;
